import { Loader2 } from 'lucide-react';
import { useState } from 'react';

interface RecordingPlayerProps {
  url: string;
}

export function RecordingPlayer({ url }: RecordingPlayerProps): React.ReactNode {
  const [ready, setReady] = useState(false);

  return (
    <div className="rounded-lg border border-border bg-card p-6">
      {!ready && (
        <div className="flex items-center justify-center py-2">
          <Loader2 className="size-5 animate-spin text-muted-foreground" />
        </div>
      )}
      <audio
        controls
        className={ready ? 'w-full' : 'hidden'}
        src={url}
        onCanPlay={() => {
          setReady(true);
        }}
      >
        <track kind="captions" />
      </audio>
    </div>
  );
}
